export function decodePasskeyBytes(value) {
    const bytes = atob(value.replace(/-/g, '+').replace(/_/g, '/'));
    return Uint8Array.from(bytes, c => c.charCodeAt(0));
}
export function encodePasskeyBytes(value) {
    return btoa(Array.from(new Uint8Array(value), b => String.fromCharCode(b)).join('')).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
export async function usePasskey(options, mode) {
    if (!window.isSecureContext || !window.PublicKeyCredential || !navigator.credentials) throw new Error('Cet appareil nécessite un navigateur compatible et une connexion HTTPS pour utiliser une passkey.');
    const publicKey = { ...options, challenge: decodePasskeyBytes(options.challenge) };
    if (publicKey.user) publicKey.user = { ...publicKey.user, id: decodePasskeyBytes(publicKey.user.id) };
    for (const key of ['allowCredentials', 'excludeCredentials']) if (publicKey[key]) publicKey[key] = publicKey[key].map(c => ({ ...c, id: decodePasskeyBytes(c.id) }));
    try {
        const credential = mode === 'create' ? await navigator.credentials.create({ publicKey }) : await navigator.credentials.get({ publicKey });
        if (!credential) throw new Error('Aucune passkey reçue.');
        const response = {};
        for (const key of ['clientDataJSON', 'attestationObject', 'authenticatorData', 'signature', 'userHandle']) {
            if (credential.response[key]) response[key] = encodePasskeyBytes(credential.response[key]);
        }
        return { type: credential.type, rawId: encodePasskeyBytes(credential.rawId), response };
    } catch (error) {
        if (['NotAllowedError', 'AbortError'].includes(error.name)) throw new Error('Vérification annulée ou expirée. Recommencez la connexion.');
        if (error.name === 'InvalidStateError') throw new Error('Une passkey existe déjà sur cet appareil. Contactez le responsable si la connexion reste impossible.');
        throw error;
    }
}
